import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { GlobalService } from 'app/global/global.service';
import { Observable, of } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { ConfirmInvitationFacadeService } from '../confirm-invitation/store/confirm-invitation-facade.service';
import { ResponseCodeEnum } from '../confirm-invitation/store/response-code.enum';

@Injectable({
  providedIn: 'root'
})
export class ConfirmInvitationGuard implements CanActivate {
  constructor(
    private confirmInvitationFacade: ConfirmInvitationFacadeService,
    private router: Router,
    private globalService: GlobalService,
    private translocoService: TranslocoService
  ) { }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const apiUrl = route.queryParamMap.get('url');

    if (!apiUrl) {
      this.globalService.toastrError(this.translocoService.translate('invite link bad url error message(confirm invitation guard) - Invitation link is invalid or missing a URL.'));
      return of(this.router.createUrlTree(['/login']));
    }

    // Dispatch the action to check the invitation link
    this.confirmInvitationFacade.checkConfirmationUrl(apiUrl);

    // Wait until invitation check finishes, then decide based on the final state.
    return this.confirmInvitationFacade.confirmInvitationUrlCheckState$.pipe(
      filter(({ loading }) => loading === false),
      take(1),
      map(({ error }) => {
        if (error) {
          this.globalService.toastrWarning(error.message || this.translocoService.translate('invite link invalid error message (confirm invitation guard) - The invitation link is invalid or has expired.'));
          if (error.status !== ResponseCodeEnum.Expired) {
            return this.router.createUrlTree(['/login']);
          }
        }
        return true;
      })
    );
  }
}
